import { render, staticRenderFns } from "./PowerConsumptionReport.vue?vue&type=template&id=b2600ca2&scoped=true"
import script from "./PowerConsumptionReport.vue?vue&type=script&lang=ts"
export * from "./PowerConsumptionReport.vue?vue&type=script&lang=ts"
import style0 from "./PowerConsumptionReport.vue?vue&type=style&index=0&id=b2600ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2600ca2",
  null
  
)

export default component.exports